// extracted by mini-css-extract-plugin
module.exports = {"footer":"Paginado_footer__3lCJ7","paginationButton":"Paginado_paginationButton__17Ean"};